<template>
  <!-- 热门咨询 -->
  <div class="hotconsult">
    <div class="hotzxbanner">
      <img src="../../assets/hotconsult/hotzxbanner_sample.png" alt="" />
    </div>
    <rmzxrmht />
    <div class="lijizixun between">
      <div>
        <div class="FontBlack FontSize22">律观网律师诊断</div>
        <div class="FontSize20 mt10 FontGray">一对一咨询，最专业的律师问题解决报告</div>
      </div>
      <div class="ljzxbtn">立即咨询</div>
    </div>
    <rmzxbomlll />
    
  </div>
</template>

<script>
import rmzxrmht from "./child/rmzxrmht";
import rmzxbomlll from './child/rmzxbomlll'
export default {
  components: {
    rmzxrmht,
    rmzxbomlll,
  },
};
</script>

<style lang="scss" scoped>
.hotconsult {
  background-color: #fff;
  .hotzxbanner {
    max-width: 1920px;
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
    img {
      width: 1920px;
    }
  }
  .lijizixun {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    padding: 0 220px;
    background: url("~assets/hotconsult/bg1.png");
    .ljzxbtn {
      width: 110px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      background: #0465EA;
      border-radius: 18px;
      font-size: 20px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>